<template>
  <div class="input-dropdown touch">
    <div v-if="icon" class="input-dropdown__icon">
      <fa :icon="icon" fixed-width />
    </div>
    <div v-if="label" class="input-dropdown__label">
      {{ label }}
    </div>
    <div class="input-dropdown__reveal input-dropdown__button input-dropdown__button--active" @click="isActive = !isActive">{{ value ? value : language.code === 'en' ? 'All' : 'جَميع' }} 
      <fa 
        class="input-dropdown__button-icon"
        :class="{ 'input-dropdown__button-icon--active' : isActive }"
        icon="chevron-down"
      />
    </div>
    <transition name="fast-fade">
      <div v-show="isActive" class="input-dropdown__buttons">
    
        <div class="input-dropdown__heading">{{ language.code === 'ar' ? 'اختر الإطلالة' : 'Select View' }}</div>
        <div 
          class="input-dropdown__button touch"
          :class="{ 'input-dropdown__button--active': selection.value === value }"
          v-for="selection in selections"
          :key="selection.value"
          @click="[$emit('input', selection.value), isActive = false]"
        >
          {{ selection.label[language.code] }}
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: [ 'icon', 'label', 'selections', 'value'],

  data () {
    return {
      isActive: false,
    }
  },

  computed: {
    ...mapGetters([
      'language'
    ]),
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
.input-dropdown {
  position: relative;

  &__icon {
    font-size: 1.2rem;

    svg {
      margin-right: 1rem;
    }
  }

  &__label {
    display: block;
    font-size: 1.5rem;
    margin-bottom: 0.5em;
  }

  &__heading {
    color: $black;
    font-size: 1.5rem;
    margin-bottom: 0.5em;
  }

  &__buttons {
    align-items: flex-start;
    background: $white;
    border-radius: .7rem;
    bottom: 4rem;
    display: flex;
    flex-direction: column;
    left: 0;
    margin-bottom: 1rem;
    overflow: hidden;
    padding: 1rem;
    position: absolute;
    right: 0;
    z-index: 10;
  }

  &__button {
    align-items: center;
    background: #333;
    border: 0.2rem solid $black;
    border-radius: 0.7rem;
    color: $white;
    display: flex;
    font-size: 1.2rem;
    justify-content: space-between;
    padding: 0.3em 0.5em;
    margin-bottom: .5rem;
    min-width: 3rem;
    // opacity: 0.6;
    text-align: left;
    transition: background-color 0.15s ease-in;
    width: 100%;

    &:last-child {
      margin: 0;
    }

    &--active {
      background: $white;
      border: 0.2rem solid $black;
      color: $black;
      opacity: 1;
    }
  }

  &__button-icon {
    // margin-left: auto;
    transform: rotate(180deg) !important;
    transition: transform 200ms ease !important;

    &--active {
      transform: rotate(0) !important;
    }
  }
}
</style>

